export const PRODUCT_SURFACE_TYPES = [
  'web',
  'ios',
  'android',
  'desktop',
  'api',
  'cli',
  'integration',
  'other',
] as const;

export type ProductSurfaceType = (typeof PRODUCT_SURFACE_TYPES)[number];

export const PRODUCT_SURFACE_TYPE_LABELS: Record<ProductSurfaceType, string> = {
  web: 'Web',
  ios: 'iOS',
  android: 'Android',
  desktop: 'Desktop',
  api: 'API',
  cli: 'CLI',
  integration: 'Integration',
  other: 'Other',
};

const ALLOWED = new Set<string>(PRODUCT_SURFACE_TYPES);

export function isProductSurfaceType(value: unknown): value is ProductSurfaceType {
  return typeof value === 'string' && ALLOWED.has(value);
}

/**
 * Ordered unique allow-listed tokens. Unknown values (including `mobile`) are dropped.
 */
export function normalizeSurfaceTypes(raw: unknown): ProductSurfaceType[] {
  if (!Array.isArray(raw)) {
    return [];
  }
  const seen = new Set<ProductSurfaceType>();
  const out: ProductSurfaceType[] = [];
  for (const item of raw) {
    if (typeof item !== 'string') {
      continue;
    }
    const token = item.trim().toLowerCase();
    if (!isProductSurfaceType(token) || seen.has(token)) {
      continue;
    }
    seen.add(token);
    out.push(token);
  }
  return out;
}

export function formatSurfaceTypesDisplay(raw: unknown): string {
  const types = normalizeSurfaceTypes(raw);
  if (types.length === 0) {
    return '';
  }
  return types.map(t => PRODUCT_SURFACE_TYPE_LABELS[t]).join(', ');
}
